module.exports = __webpack_public_path__ + "static/media/bImage-mobile.812be6ba.png";